/* eslint-disable */

// libraries
import React, { Fragment } from 'react';
import unified from 'unified';
import parse from 'rehype-parse';
import rehype2react from 'rehype-react';
import styled from 'styled-components';

// styled components
import { H4, Text } from 'shared/typography';
import { Link, Flex } from 'shared/styledComponents';

// styles
import devices from 'theme/devices';

const StyledH4 = styled(H4)<any>`
  font-size: 24px;

  @media ${devices.mobile} {
    font-size: 18px;
  }
`;

const StyledLink = styled(Link)<any>`
  font-family: ${({ theme: { fonts } }): string => fonts.wigrumRegular};
  font-size: 14px;
  line-height: 22px;
  text-decoration: underline;
`;

const UnorderedList = styled.ul<any>`
  list-style-position: inside;
  margin-bottom: 20px;
`;

const OrderedList = styled.ol<any>`
  list-style-position: inside;
  margin-bottom: 20px;
`;

const processor: any = unified()
  .use(parse)
  .use(rehype2react, {
    createElement: React.createElement,
    components: {
      // Map HTML element tag to React component
      html: Fragment,
      head: Fragment,
      body: Fragment,
      h2: (props: any) => <StyledH4 as="h2" {...props} />,
      p: (props: any) => <Text size="small" {...props} />,
      a: StyledLink,
      ul: UnorderedList,
      ol: OrderedList,
      li: (props: any) => <Text as="li" size="small" {...props} />,
    },
  });

const parseHtml = (string: string): any => processor.processSync(string).result;

export default parseHtml;
